import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { useTheme } from '@material-ui/core/styles';
import MbCheckList from 'components/molecules/MbCheckList';
import Button from '@material-ui/core/Button';
import MbButton from 'components/atoms/MbButton';
import { useTranslation } from 'react-i18next';
import {useSelector} from "react-redux";

const checkListStyles = makeStyles((theme) => ({
  contentWrap: { display: 'flex', flexDirection: 'row', flexWrap: 'wrap' },
  resetButton: { fontSize: 15 },
}));

/**
 * 필터 체크리스트 및 전체 선택 | 초기화, 저장버튼 포함
 */
const DisplayTpList = (props) => {
  const {
    list,
    advrtsPrdtCode = null,
    advrtsTpCode = {},
    displayFilterList = false,
    handleSubmit,
    handleTpClick,
    isTargetingState = null,
    ...rest
  } = props;

  const classes = checkListStyles();
  const { t } = useTranslation();
  const theme = useTheme();
  const { chkAdvrtsGroup = null } = useSelector(
      ({ common }) => ({
        chkAdvrtsGroup: common.advrtsGroupList[advrtsPrdtCode],
      })
  );

  const handleOnClick = (value) => {
    let checked = true;
    if (value === 'Y' || value === 'N') {
      if (value === 'N') {
        checked = false;
      }
    } else {
      if (typeof advrtsTpCode[value] !== 'undefined') {
        // 기존에 있던 값이면 빼기
        checked = false;
      }
    }
    handleTpClick(isTargetingState, value, checked);
  };

  return (
    <>
      <div className={classes.contentWrap}>
        {(() => {
          let result = [];
          for (let item of list) {
            const { label, value } = item;
            if (value === '00') continue;
            if (!!displayFilterList) {
              // 특정 타게팅만 노출시키고 싶을 때
              if (
                isTargetingState !== null &&
                !!displayFilterList[isTargetingState]
              ) {
                if (
                  typeof displayFilterList[isTargetingState][value] !==
                    'undefined' &&
                  typeof displayFilterList[isTargetingState][value] === 'number'
                ) {
                  result.push(
                    <MbCheckList
                      key={`${label}_${value}`}
                      label={label}
                      onClick={() => handleOnClick(value)}
                      checked={
                        advrtsPrdtCode === isTargetingState &&
                        typeof advrtsTpCode[value] !== 'undefined'
                      }
                      {...rest}
                    />
                  );
                }
              }
            } else {
              // 모든 타게팅 노출
              result.push(
                <MbCheckList
                  key={`${label}_${value}`}
                  label={label}
                  onClick={() => handleOnClick(value)}
                  checked={
                    advrtsPrdtCode === isTargetingState &&
                    typeof advrtsTpCode[value] !== 'undefined'
                  }
                  {...rest}
                />
              );
            }
          }
          return result;
        })()}
      </div>
      <div>
        <Button
          className={classes.resetButton}
          onClick={() => handleOnClick('Y')}
        >
          {t('전체선택')}
        </Button>
        <Button
          className={classes.resetButton}
          onClick={() => handleOnClick('N')}
        >
          {t('전체해제')}
        </Button>
        {(() => {
          let result = [];
          if(isTargetingState && chkAdvrtsGroup) {
            for(let tg of chkAdvrtsGroup) {
              result.push(
                <Button
                    className={classes.resetButton}
                    onClick={() => handleOnClick(tg['list'])}
                >
                {t(tg['name'])}
                </Button>
              )
            }
          }
          return result;
        })()}
        <MbButton
          style={{ float: 'right' }}
          color={theme.palette.primary.deep}
          clickEvent={() => handleSubmit()}
        >
          {t('확인')}
        </MbButton>
      </div>
    </>
  );
};

export default DisplayTpList;
